<template>
    <div
        ref="videoRef"
        class="video-component"
    >
        <div :style="videoBoxStyle">
            <img 
                class="poster"
                :src="cover"
                v-if="cover"
                :style="videoBoxStyle"
            />
            <video
                v-if="source"
                loop
                ref="video"
                class="video"
                :style="videoBoxStyle"
                type="video/mp4"
                preload="meta"
                :poster="cover"
                @click="playToggle"
                @pause="videoPaused"
                @play="videoPlayed"
                :src="source"
                x5-playsinline
                playsinline
                webkit-playsinline
            ></video>
            <img
                class="poster"
                v-if="cover && !playing && !hasPlayed"
                :src="cover"
                @click="playVideo"
                :style="videoBoxStyle"
            />
            <div>
                <img
                    class="play-btn"
                    v-show="!playing && source"
                    @click="playVideo"
                    src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/a-play-btn.png"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Video",
    props: {
        videoId: {
            type: [Number, String],
        },
        cover: {
            type: String,
            default: "",
        },
        source: {
            type: String,
            default: "",
        },
        width: {
            type:[String, Number],
            default: 0,
        },
        height: {
            type:[String, Number],
            default: 0,
        },
        radius: {
            type:[String, Number],
            default: 0,
        },
    },
    data() {
        return {
            poster: "",
            videoWidth: 0,
            videoHeight: 0,
            playing: false,
            hasPlayed: false, // 视频播放过了
        };
    },
    watch: {
        source: { //深度监听，可监听到对象、数组的变化
            handler() {
                console.log('换视频了---')
                this.playing = false;
                this.hasPlayed = false;// 视频播放过了
            },
            deep: true,
        },
    },
    computed: {
        videoBoxStyle() {
            return {
                width: this.width !=='100%' ? this.width + 'px' : '100%',
                height: this.height !=='0' ? this.height + 'px' : 'auto',
                'border-radius': `${this.radius}rem`,
            };
        },
        videoRef() {
            return this.$refs.video;
        },
    },
    methods: {
        playToggle() {
            this.playing ? this.pauseVideo() : this.playVideo();
        },
        videoPaused() {
            this.playing = false;
        },
        videoPlayed() {
            this.playing = true;
        },
        pauseVideo() {
            this.videoRef?.pause();
        },
        playVideo() {
            const videos = document.getElementsByTagName('video') || [];
            this.$audioPlayer.src = '';
            [...videos].forEach(item => {
                item?.pause();
            });
            this.hasPlayed = true;
            this.videoRef?.play();
        },
       handleVisibilityChange() {
           if(document.hidden){
                this.$audioPlayer.src = '';
                this.videoRef?.pause();
                
           } 
        },
    },
    mounted() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
        const {width, height} = this.$refs.videoRef.getBoundingClientRect();
        this.videoWidth = width;
        this.videoHeight = height;
    },
    created() {
        this.poster = this.$props.source;
        // ios兼容webpg格式图片
        if (this.poster.indexOf('webp') !== -1) {
            this.poster = `${this.poster.split('?')[0]}.webp`;
        }
    },
};
</script>

<style lang="less" scoped>
.video-component {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .video {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .poster {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-size: cover;
    }
    .play-btn {
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>
